import React from "react";
import "./services.css";
import { BiCheck } from "react-icons/bi";

const Services = () => {
  return (
    <section id="services">
      <h5>What I Offer</h5>
      <h2>Services</h2>

      <div className="container services__container">
        <article className="service">
          <div className="service__head">
            <h3>UI/UX Design</h3>
          </div>

          <ul className="service__list">
            <li>
              <BiCheck className="service__list-icon" />
              <p>Logo Design</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Web Design</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Powerpoint</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Menu Design</p>
            </li>
          </ul>
        </article>

        <article className="service">
          <div className="service__head">
            <h3>Web Develoment</h3>
          </div>

          <ul className="service__list">
            <li>
              <BiCheck className="service__list-icon" />
              <p>Simple CMS web site</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Blog web site</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Simple ecommerce website</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Forums and News website</p>
            </li>
          </ul>
        </article>
      </div>
    </section>
  );
};

export default Services;
